import React, { useState, useRef } from 'react';
import _ from 'lodash';
// utilities
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';

// components
import { Information, Confirmation } from '../modals/common';

// services
import { LwApiSettings } from '../../services/LwApiSettings'; // LINE WORKS API設定詳細取得API
import SessionStorageService from '../../services/utilities/SessionStorageService';

//pages
import { useGetReloadExternalServiceCooperationPage } from '../../pages/ExternalServiceCooperation';

export default function LwUnconnectingModal({
  visible,
  setVisible,
  lwApiSettingId,
}) {
  const [
    isShowUnconnectingSuccessModal,
    setIsShowUnconnectingSuccessModal,
  ] = useState(false);
  const [
    isShowUnconnectingFaildModal,
    setIsShowUnconnectingFaildModal,
  ] = useState(false);
  const [unconnectingFaildMessage, setUnconnectingFaildMessage] = useState('');
  const isSending = useRef(false);
  return (
    <React.Fragment>
      <Confirmation
        visible={visible}
        title={messageUtility.getMessage('I-001-526')}
        message={messageUtility.getMessage('I-001-527')}
        confirmButtonText={messageUtility.getMessage('I-001-528')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        isNegative={true}
        onCancel={() => {
          setVisible(false);
        }}
        onConfirm={async () => {
          if (isSending.current) {
            return;
          }
          isSending.current = true;
          const fieldId = SessionStorageService.getFieldId();
          // 削除API呼び出し
          const response = await LwApiSettings.del(fieldId, lwApiSettingId);
          if (response.result) {
            setVisible(false);
            setIsShowUnconnectingSuccessModal(true);
            isSending.current = false;
          } else {
            const message =
              response.status === STATUS_CODE.badRequest &&
              !_.isNil(response.data.message)
                ? response.data.message
                : messageUtility.getMessage('E-001-438');
            setUnconnectingFaildMessage(message);
            setVisible(false);
            setIsShowUnconnectingFaildModal(true);
            isSending.current = false;
          }
        }}
      />
      <LwUnconnectingSuccessModal
        visible={isShowUnconnectingSuccessModal}
        setVisible={setIsShowUnconnectingSuccessModal}
        isSending={isSending}
      />
      <LwUnconnectingFaildModal
        visible={isShowUnconnectingFaildModal}
        setVisible={setIsShowUnconnectingFaildModal}
        errorMessage={unconnectingFaildMessage}
      />
    </React.Fragment>
  );
}

function LwUnconnectingSuccessModal({ visible, setVisible, isSending }) {
  const reloadExternalServiceCooperationPage = useGetReloadExternalServiceCooperationPage();
  return (
    <Information
      visible={visible}
      title={messageUtility.getMessage('I-001-526')}
      message={messageUtility.getMessage('I-001-529')}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        if (isSending.current) {
          return;
        }
        isSending.current = true;
        setVisible(false);
        reloadExternalServiceCooperationPage();
        isSending.current = false;
      }}
    />
  );
}

function LwUnconnectingFaildModal({ visible, setVisible, errorMessage }) {
  return (
    <Information
      visible={visible}
      title={messageUtility.getMessage('I-001-526')}
      message={errorMessage}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        setVisible(false);
      }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/LwUnconnectingModal.jsx